var map = {
	"./decidim/gamification/badges/decidim_gamification_badges_accepted_proposals.svg": 56633,
	"./decidim/gamification/badges/decidim_gamification_badges_proposal_votes.svg": 9446,
	"./decidim/gamification/badges/decidim_gamification_badges_proposals.svg": 71379,
	"./decidim/proposals/decidim_proposals.svg": 84291,
	"./decidim/proposals/proposal-placeholder-card-g.svg": 50387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15396;